/* Zahlung DE AI: progressive enhancements. Navigation and forms work without JS. */
(() => {
  if (customElements.get('zahlung-header')) return;
  class ZahlungHeader extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.menu = this.querySelector('.z-mobile-nav');
      this.menuButton = this.menu?.querySelector('summary');
      this.hostSection = this.closest('.z-header-section');
      this.updateScroll = () => this.toggleAttribute('data-scrolled', window.scrollY > 12);
      this.updateSize = () => {
        const height = Math.ceil(this.getBoundingClientRect().height);
        document.documentElement.style.setProperty('--z-header-height', `${height}px`);
      };
      if (this.hostSection) this.hostSection.style.position = this.dataset.sticky === 'true' ? 'sticky' : 'relative';
      window.addEventListener('scroll', this.updateScroll, { ...options, passive: true });
      this.updateScroll();
      this.updateSize();
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.updateSize);
        this.resizeObserver.observe(this);
      }
      this.menu?.addEventListener('toggle', () => this.menuButton?.setAttribute('aria-expanded', String(this.menu.open)), options);
      this.menuButton?.setAttribute('aria-expanded', String(this.menu.open));
      this.menu?.addEventListener('click', (event) => {
        if (event.target.closest('a')) this.menu.open = false;
      }, options);
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (this.menu?.open) {
          this.menu.open = false;
          this.menuButton?.focus();
        }
        this.querySelectorAll('.z-nav-dropdown[open]').forEach((item) => {
          item.open = false;
          item.querySelector('summary')?.focus();
        });
      }, options);
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target) && this.menu?.open) this.menu.open = false;
        this.querySelectorAll('.z-nav-dropdown[open]').forEach((item) => {
          if (!item.contains(event.target)) item.open = false;
        });
      }, options);
      this.breakpoint = window.matchMedia('(min-width: 990px)');
      this.breakpoint.addEventListener('change', () => {
        if (this.breakpoint.matches && this.menu?.open) this.menu.open = false;
      }, options);
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
    }
  }
  customElements.define('zahlung-header', ZahlungHeader);
})();
